export default "__VITE_ASSET__BON4Av2k__"